import React, { Fragment as _, memo, useContext } from 'react';
import {
  Row,
  Column,
  SingleColumnLayout,
  TwoColumnLayout,
} from 'components/UI/ColumnAndRow';
import { Block } from 'factories/block';
import { Accordion, Field, FieldHeader, FieldBody } from './Accordion';
import EditableText from 'components/lib/EditableText';
import Image from '../Image';
import Container from 'components/Layouts/ContainerLogical';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import EditableButton from 'components/lib/EditableBtn';
import getBlockById from 'services/apiHelpers/getBlockById';
import { interactionContext as InteractionContext } from './interactionContext';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import Transcript from 'components/lib/Video/Transcript';
import SVG from 'components/lib/SVG';
import Media, { MediaContext, IMediaContext } from 'components/lib/Media';
import { imgPlaceholders } from 'components/lib/Image';
import shouldUpdate from 'services/shouldUpdate';
import imagePlaceholder from 'assets/CC_Add In Image Transparent_min.png';
import accordionImgPlaceholder from 'assets/Long Rectangle.svg';
import Embed from 'components/lib/Embed';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';

const ComponentsObject = {
  Row,
  Column,
  Text: EditableText,
  InteractionColumn: ({ children, ...props }) => {
    const interactionContext = useContext(InteractionContext);
    const { includeAdditionalTextField } = interactionContext.props;

    const [accordion, txt] = children;

    if (!includeAdditionalTextField) {
      return accordion;
    }

    return (
      <_>
        {accordion}
        <div
          style={{
            margin: '20px 0 0 0',
          }}
        >
          {txt}
        </div>
      </_>
    );
  },

  Accordion: ({ children, ...props }) => {
    return (
      <div style={{ width: '100%' }}>
        <Accordion {...props}>{children}</Accordion>
      </div>
    );
  },
  AccordionField: Field,
  AccordionHeader: FieldHeader,
  AccordionBody: FieldBody,

  Image: ({ children, ...props }) => {
    const mediaContext = useContext(MediaContext) as IMediaContext;
    const { isAdditionalMedia } = mediaContext;

    return (
      <Image
        {...{
          ...props,
          placeholder: accordionImgPlaceholder || imgPlaceholders[1],
        }}
      />
    );
  },

  Video: ({ children, ...props }) => {
    return (
      <_>
        <Video {...props}>{children}</Video>
        {props.useTranscript && <div style={{ height: 30 }} />}
      </_>
    );
  },
  Audio,
  Transcript,
  Modal: () => null,
  SVG,
  Embed,
  Media,
  PDF,
  OpenPDF,
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton,
};

const render = (block: Block, Components: {}): JSX.Element | string => {
  let b = block;
  if (b.type === 'Ref') {
    b = getBlockById(b.id);
  }

  const children = Array.isArray(b.children)
    ? (b.children as Block[]).map((c) => render(c, Components))
    : b.children;

  const Component = Components[b.type];

  return (
    <Component key={b.id} id={b.id} {...b.props}>
      {children}
    </Component>
  );
};

interface DisplayProps {
  blockId: string;
  interactionBlock?: Block;
}

const AccordionDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider value={interactionBlock}>
        {(interactionBlock.children as Block[]).map((child) => {
          return render(child, ComponentsObject);
        })}
      </InteractionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default AccordionDisplay;
